export enum localStorageKeys {
    FBToken = "firebase_token",
}